var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('PSelectKeyValue',{attrs:{"options":_vm.countries,"value":_vm.value,"label":"label","track-by":"value","multiple":true,"allow-empty":"","placeholder":_vm.$pgettext('core.label','Select Countries')},on:{"update:value":_vm.onInput}})}
var staticRenderFns = []

export { render, staticRenderFns }